import React from 'react'
import { useForm, Link, usePage } from '@inertiajs/react'
import { Box, Paper, Typography, TextField, Button, Stack, Alert } from '@mui/material'

interface Props {
  errors?: Record<string, string[]>
}

interface SharedProps {
  flash?: { notice?: string | null; alert?: string | null }
}

function ForgotPassword({ errors: serverErrors = {} }: Props) {
  const page = usePage<SharedProps>()
  const flash = page.props.flash || {}

  const { data, setData, post, processing } = useForm({
    user: { email: '' },
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/users/password')
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 120px)', p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 420, width: '100%' }}>
        <Typography variant="h4" sx={{ mb: 1, textAlign: 'center' }}>Reset your password</Typography>
        <Typography variant="body2" sx={{ mb: 3, textAlign: 'center', color: 'text.secondary' }}>
          Enter your email and we will send instructions.
        </Typography>

        {flash.notice && <Alert severity="success" sx={{ mb: 2 }}>{flash.notice}</Alert>}
        {flash.alert && <Alert severity="error" sx={{ mb: 2 }}>{flash.alert}</Alert>}

        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="Email"
              type="email"
              value={data.user.email}
              onChange={(e) => setData('user', { email: e.target.value })}
              error={Boolean(serverErrors.email)}
              helperText={serverErrors.email?.join(', ')}
              required
              fullWidth
            />
            <Button type="submit" variant="contained" size="large" disabled={processing}>
              Send instructions
            </Button>
          </Stack>
        </form>

        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Link href="/users/sign_in">Back to sign in</Link>
        </Box>
      </Paper>
    </Box>
  )
}

;(ForgotPassword as React.ComponentType & { noLayout?: boolean }).noLayout = true

export default ForgotPassword
